<template>
  <div>
    <div class="houselist">
      <div class="houselist-t">
        <div class="houselist-t-1">我的委托</div>
        <div class="houselist-t-2"></div>
      </div>
    </div>
    <div class="adminhouse">
      <ul>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
        >
          <li v-for="(item,index) in lists" :key="index">
            <div class="litop">
              <div class="info">
                <h1>
                  {{item.xingzhi}}
                  <span style="font-size:12px;color:#888;float:right">{{item.addtime_cn}}</span>
                </h1>
                <p class="txt3">小区：{{item.xiaoqu}}</p>
                <p class="txt3">地址：{{item.address}}</p>
              </div>
            </div>
          </li>
        </van-list>
      </ul>
    </div>

    <footbar />
  </div>
</template>

<script>
var root = process.env.VUE_APP_API_URL;

import Footbar from "../../commpents/footbar";

import {
  Toast,
  DropdownMenu,
  DropdownItem,
  TreeSelect,
  Tag,
  List,
  Icon,
  Button,
  Dialog,
  Tab,
  Tabs,
  Row,
  Col,
  Search
} from "vant";

export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [TreeSelect.name]: TreeSelect,
    [Tag.name]: Tag,
    [List.name]: List,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Row.name]: Row,
    [Col.name]: Col,
    [Search.name]: Search,

    Footbar
  },

  data() {
    return {
      getInitUrl: root + "user/tuoguan",
      getRefreshUrl: root + "user/refresh",
      getStickyUrl: root + "user/sticky",
      getDelUrl: root + "user/del",
      getCloseUrl: root + "user/close",
      getOpenUrl: root + "user/open",
      value: 0,
      type: "zufang",
      page: 1,
      k: "",
      lists: [],
      total: 0,
      loading: false,
      finished: false,
      active: 0
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      var self = this;
      $.ajax({
        url: self.getInitUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: { page: self.page, type: self.type },
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          var lists = reponseData.data.lists;
          if (lists.length == 0) {
            self.finished = true;
          }
          self.loading = false;
          self.total = reponseData.data.total;
          for (var i in lists) {
            self.lists.push(lists[i]);
          }
          self.page++;
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },
    getData(name, title) {
      this.page = 1;
      this.lists = [];
      this.loading = true;
      this.finished = false;

      if (this.active == 0) {
        this.type = "1";
      }
      if (this.active == 1) {
        this.type = "2";
      }
      if (this.active == 2) {
        this.type = "3";
      }
      this.init();
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        if (this.page >= this.total) {
          this.finished = true;
          this.loading = false;
          return;
        }
        this.loading = true;
        this.init();
      }, 500);
    },
    refresh(id, type) {
      var self = this;
      $.ajax({
        url: self.getRefreshUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: { id: id, type: type },
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          self.$toast(reponseData.message);
          if (reponseData.status == 0) {
            self.$router.push("/user/refresh/" + id);
          }
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },
    sticky(id, type) {
      var self = this;
      $.ajax({
        url: self.getStickyUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: { id: id, type: type },
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          self.$toast(reponseData.message);
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },
    del(id, index, type) {
      var self = this;
      this.$dialog
        .confirm({
          title: "删除提示",
          message: "确定删除这个房源吗？删除后不可恢复了额",
          confirmButtonText: "我要删除",
          cancelButtonText: "不删除",
          confirmButtonColor: "#ee0a24"
        })
        .then(() => {
          $.ajax({
            url: self.getDelUrl,
            timeout: 120000,
            dataType: "json",
            type: "get",
            data: { id: id, type: type },
            headers: self.getRequestHeader(),
            success: function(reponseData, status) {
              self.$toast(reponseData.message);
              if (reponseData.status == 1) {
                self.lists.splice(index, 1);
              }
            },
            error: function() {
              self.$toast("system error");
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    close(id, index, type) {
      var self = this;
      this.$dialog
        .confirm({
          title: "下架提示",
          message: "我确定下架该房源，下架房源将不在显示",
          confirmButtonText: "我要下架",
          cancelButtonText: "不下架",
          confirmButtonColor: "#ee0a24"
        })
        .then(() => {
          $.ajax({
            url: self.getCloseUrl,
            timeout: 120000,
            dataType: "json",
            type: "get",
            data: { id: id, type: type },
            headers: self.getRequestHeader(),
            success: function(reponseData, status) {
              self.$toast(reponseData.message);
              if (reponseData.status == 1) {
                self.lists.splice(index, 1);
              }
            },
            error: function() {
              self.$toast("system error");
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    open(id, index, type) {
      var self = this;
      this.$dialog
        .confirm({
          title: "上架提示",
          message: "我确定上架该房源，上架房源将持续展示",
          confirmButtonText: "我要上架",
          cancelButtonText: "不上架",
          confirmButtonColor: "#ee0a24"
        })
        .then(() => {
          $.ajax({
            url: self.getOpenUrl,
            timeout: 120000,
            dataType: "json",
            type: "get",
            data: { id: id, type: type },
            headers: self.getRequestHeader(),
            success: function(reponseData, status) {
              self.$toast(reponseData.message);
              if (reponseData.status == 1) {
                self.lists.splice(index, 1);
              }
            },
            error: function() {
              self.$toast("system error");
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>

<style scoped>
.user {
  background-color: #3072f6;
  display: flex;
  padding: 30px 25px;
  color: #fff;
}
.avatar-img {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar-img img {
  width: 80%;
}
.avatar-info {
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar-info h1 {
  font-size: 18px;
}
.avatar-info p {
  font-size: 14px;
  color: #fff;
  padding: 4px 0;
}
.user-tag {
  text-align: center;
  padding: 15px 0;
}
.user-tag img {
  width: 40px;
}
.user-tag h1 {
  margin-top: 6px;
  font-size: 14px;
  font-weight: normal;
  color: #555;
}
.user-logout {
  text-align: center;
  padding: 15px;
  margin: 15px;
  background-color: #f8f8f8;
  border-radius: 4px;
}
</style>>



